import React from "react";
import {
  TopHeaderFacebookIcon,
  TopHeaderInstagram,
  TopHeaderLinkedIn,
  TopHeaderTwitterIcon,
  TopHeaderYouTubeIcon,
} from "../common/Icons";

const TopHeader = () => {
  return (
    <div className="top-header-section py-3 open_overlay_sections_none">
      <div className="container d-flex justify-content-between  align-items-center flex-column flex-lg-row">
        <div>
          <a href="https://twitter.com/" target="_blank">
            <TopHeaderTwitterIcon />
          </a>
          <a href="https://www.linkedin.com/feed/" target="_blank">
            <TopHeaderLinkedIn />
          </a>
          <a href="https://www.facebook.com/" target="_blank">
            <TopHeaderFacebookIcon />
          </a>

          <a href="https://www.instagram.com/?hl=en" target="_blank">
            <TopHeaderInstagram />
          </a>
          <a href="https://www.youtube.com/" target="_blank">
            <TopHeaderYouTubeIcon />
          </a>
        </div>
        <p className="font-sm text-white mb-0 mt-3 mt-lg-0">
          +91 012345678 Global Technologie@gmail.com
        </p>
        <p className="font-sm text-white mb-0 mt-2 mt-lg-0">
          Material Downloads
        </p>
      </div>
    </div>
  );
};

export default TopHeader;
